import {request,_urlProject} from "../api";
import {PROJECT_CONSTS} from "../constants";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetProjects = () => {
    const requestData = {
        url: _urlProject,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: PROJECT_CONSTS.GET_PROJECTS,
                    payload: data
                });
            })
    }
};


export const DeleteProjectById = id => {
    const requestData = {
        url:  `${_urlProject}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: PROJECT_CONSTS.DELETE_PROJECT_BY_ID,
                    payload: id
                });
            })
            .catch(() => {})
    }
};

export const CreateProject = data => {
    const requestData = {
        url: _urlProject,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: PROJECT_CONSTS.CREATE_PROJECT,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Նախագիծը հաջողությամբ ստեղծվեց!"
                })
                history.push('/project')
            })
            .catch(() => {
            })
    }
};

export const UpdateProjectById = (id, data) => {
    const requestData = {
        url: `${_urlProject}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: PROJECT_CONSTS.UPDATE_PROJECT_BY_ID,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Նախագիծը հաջողությամբ փոփոխվեց!"
                })
                history.push('/project')
            })
            .catch(() => {
            })
    }
};

export const UpdateProjectsPositions = items => {
    const requestData = {
        url: _urlProject,
        token: true,
        method: "PUT",
        data: items
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: PROJECT_CONSTS.UPDATE_PROJECTS_POSITIONS
                });
                notificationSuccess({
                    description: "Նախագիծը հաջողությամբ թարմացվեց!"
                })
            })
            .catch(() => {
            })
    }
};
